import React from 'react';
import cn from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { modalStateSelector } from '@actions/ui';
import SelectOptionModal from '../SelectOption';
import { selectGroup, updateGroup } from '@actions/groups';
import { cadenceOptions } from '@views/Group/GroupReconnect';
import styles from './GroupReconnect.module.scss';

export default function GroupReconnectModal({ closeModal }: { closeModal: () => void }) {
  const dispatch = useDispatch();
  const { groupID } = useSelector(modalStateSelector);
  const group = useSelector(selectGroup(groupID));

  const options = Object.entries(cadenceOptions).map(([key, { label, icon }]) => ({
    title: label,
    icon,
    action: () => {
      if (group.reconnect_cadence === key) {
        return;
      }

      const groupWithUpdatedCadence = group.copyWith({ reconnect_cadence: key });
      dispatch(
        updateGroup({
          group: groupWithUpdatedCadence,
          requestPayload: group.diff(groupWithUpdatedCadence),
        }),
      );
    },
    className: cn(group.reconnect_cadence === key && styles.selected),
  }));

  return (
    <SelectOptionModal
      closeModal={closeModal}
      header={<>Cadence - {cadenceOptions[group.reconnect_cadence].label}</>}
      options={options}
    />
  );
}
